var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.457031,
    y: 0.481445,
    width: 21.044,
    height: 21.044,
    rx: 2.09759,
    fill: "#FFC814"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9967,
    cy: 11.0212,
    r: 6.70711,
    stroke: "white",
    strokeWidth: 1.49047
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90946 11.0213L10.1452 13.257L13.8713 8.78558",
    stroke: "#0096FF",
    strokeWidth: 1.49047
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.d9666aa70802a9fc4c28257ec0b5130a.svg";
export { ForwardRef as ReactComponent };